/**
 * Monthly plan maths for a plan row — the same rules the server applies
 * (control-tower services/catalog-plan/plan-allocation.js):
 *
 *  - closed months (calendar months that have ended) show the ACTUAL sales;
 *  - open months split what's left of the annual target
 *    (plan − closed actuals, never below 0) by the row's monthly shape —
 *    the planner's month edits — else last year's shape, else evenly.
 *
 * All amounts are raw $.
 */

const MONTH_COUNT = 12;

const sum = (a) => (a || []).reduce((s, v) => s + (Number(v) || 0), 0);

const toTwelve = (a) =>
  Array.from({ length: MONTH_COUNT }, (_, i) => {
    const v = Number(a?.[i]);
    return Number.isFinite(v) && v > 0 ? v : 0;
  });

export const closedActualTotal = (actualMonthly, closed) =>
  sum(toTwelve(actualMonthly).slice(0, closed));

export const normalizeRowMonthly = (planValue, shape, actualMonthly, closed, fallbackShape) => {
  const actual = toTwelve(actualMonthly);
  const remaining = Math.max(0, (Number(planValue) || 0) - sum(actual.slice(0, closed)));
  const open = MONTH_COUNT - closed;
  const pick = [shape, fallbackShape]
    .map(toTwelve)
    .find((s) => sum(s.slice(closed)) > 0);
  return Array.from({ length: MONTH_COUNT }, (_, i) => {
    if (i < closed) return actual[i];
    if (open <= 0 || remaining <= 0) return 0;
    return pick ? (remaining * pick[i]) / sum(pick.slice(closed)) : remaining / open;
  });
};

/** Plan units: closed months = actual units; open months = plan $ ÷ price (null without a price). */
export const planUnitsMonthly = (planMonthly, actualUnitsMonthly, closed, avgUnitPrice) => {
  const price = Number(avgUnitPrice) || 0;
  return Array.from({ length: MONTH_COUNT }, (_, i) => {
    if (i < closed) return Number(actualUnitsMonthly?.[i]) || 0;
    return price > 0 ? (Number(planMonthly?.[i]) || 0) / price : null;
  });
};
